export default __webpack_public_path__ + "static/media/signup.0f1a0f68.svg";